import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Box, IconButton } from '@mui/material';
import { useTheme } from "@mui/material";
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';


function roundtotwo(number) {
    return Math.round(number * 100) / 100;
}


//return payment status color
export const getpaymentcolor = (status) => {
    if (status == "unpaid") {
        return "orange"
    }
    if (status == "paid") {
        return "green"
    }
}

//issue color
export const getissuecolor = (status) => {
    if (status == "pending") {
        return "red"
    }
    if (status == "active") {
        return "orange"
    }
    if (status == "completed") {
        return "green"
    }
}



//currency seperator
export const currencyseperator = (amount) => {
    return amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0.00;
}

//millisecods to minutes
export function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}


//check number
export const checknumber = (number) => {
    if (number % 2 == 0) {
        return false
    }
    else {
        return true
    }
}

//return status style
export const getstyle = (status) => {
    if (status == "Completed") {
        return "finishedbutton"
    }
    if (status == "Accepted") {
        return "activebutton"
    }
    if (status == "Pending") {
        return "pendingbutton"
    }
    if (status == 'Cancelled') {
        return "cancelledbutton"
    }
}


export function Maketext(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}



//check image file extension
export const checkimageextension = (filename) => {
    const fileextension = filename.split('.').pop();
    if (fileextension !== 'jpg' && fileextension !== 'png' && fileextension !== 'jpeg' && fileextension !== 'JPG' && fileextension !== 'PNG' && fileextension !== 'JPEG') {
        return false;
    } else {
        return true;
    }
}

//change file to base64
export const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}

//change file from base 64 to png
export const base64tofile = (dataurl, filename) => {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

//close table menu
export const handleMenuItemClick = (popupState, action) => {
    action();
    popupState.close(); // Close the menu
};




//navigate to
//scroll page to the specified section
export const navigatetopath = (path) => {
    document.getElementById(path).scrollIntoView({ behavior: 'smooth' });
}

export function formatDate(dateString) {
    const date = new Date(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')}${hours < 12 ? 'am' : 'pm'}`;

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;

    return `${formattedTime} ${formattedDate}`;
}

//shuffle an array
export const Shuffle = (array) => {
    if (Array.isArray(array)) {
        let currentIndex = array.length, randomIndex;
        // While there remain elements to shuffle.
        while (currentIndex != 0) {

            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }
        return array;
    } else {
        return [];
    }
}

//capture screenshot
export const captureScreenshot = (id, name, type) => {
    const element = document.getElementById(id); // ID of the element you want to capture

    if (type === 'pdf') {//if type has been specified to be pdf
        html2canvas(element).then(canvas => {
            const imageData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            const imgWidth = pdf.internal.pageSize.getWidth();
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imageData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save(`${name}.pdf`);
        });
    } else {//if no type has been specified or image selected
        html2canvas(element).then(canvas => {
            const screenshot = canvas.toDataURL();
            const link = document.createElement('a');
            link.href = screenshot;
            link.download = `${name}.png`;
            link.click();
        });
    }
};

// Function to format timestamp to readable date
export function formatTimestampToDate(timestamp) {
    const date = new Date(timestamp);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
}




export function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}


//capitalize each word in a sentence
export function capitalize(sentence) {
    if (sentence) {
        // Split the sentence into words
        const words = sentence.split(' ');

        // Iterate through each word
        const capitalizedWords = words.map((word) => {
            // Capitalize the first letter and convert the rest to lowercase
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });

        // Join the capitalized words back into a sentence
        return capitalizedWords.join(' ');
    }

}

//set favicon
export function setFavicon(url) {
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.href = url;

    document.getElementsByTagName("head")[0].appendChild(link);
}
